module.exports = __webpack_public_path__ + "app-static/img/01.05c944f1.png";